/**
 * 网络请求配置
 */
 import axios from "axios";

 const HOST = process.env.REACT_APP_API

 axios.defaults.timeout = 100000;
 axios.defaults.baseURL = '';
 
 /**
  * http request 拦截器
  */
 axios.interceptors.request.use(
   (config) => {
     config.data = JSON.stringify(config.data);
     return config;
   },
   (error) => {
     return Promise.reject(error);
   }
 );
 
 /**
  * http response 拦截器
  */
//  axios.interceptors.response.use(
//    (response) => {
//      if (response.data.errCode === 2) {
//        console.log("error");
//      }
//      return response;
//    },
//    (error) => {
//      console.log("quest error", error);
//    }
//  );
 
 /**
  * 封装get方法
  * @param url  请求url
  * @param params  请求参数
  * @returns {Promise}
  */
 export function get(url: any, params: any = {}, config: any = {}) {
  return new Promise((resolve, reject) => {
   // config.langCode = ''
  //  const token = getCookie('token')
  //  console.log(url, config, '配置0')
  //  if (token) {
  //    config['headers']['Authorization'] = token
  //  }

   // console.log(url, config, '配置1')
    axios.get(url, {
        params: params,
        ...config
      },).then((response) => {
        if (response) {
          if (response.data) {
            landing(url, params, response.data);
            resolve(response.data);
          } else {
           resolve(response);
          }
        } else {
         resolve(response);
        }
      })
      .catch((error) => {
        reject(error);
      })
  });
}
 
 /**
  * 封装post请求
  * @param url
  * @param data
  * @returns {Promise}
  */
 
  export function post(url: any, data: any, config: any = {headers: {}}, isParams: any = false) {
  return new Promise((resolve, reject) => {
    console.log('config post', config, data);
   //  config['headers'].langCode = getStorageLng()
   //  config['headers'].token = window.TOKEN || getStorage('token')
  //  const token = getCookie('token')
  //  if (token) {
  //    config['headers']['Authorization'] = token
  //  }
    if (isParams) {
      axios.post(url, {}, {
       ...config,
       params:  data
      }).then(
        (response) => {
          //关闭进度条
          const res: any = response ? response.data : {}
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    } else {
     axios.post(url, data, config).then(
       (response) => {
         //关闭进度条
         const res: any = response ? response.data : {}
         resolve(res);
       },
       (err) => {
         reject(err);
       }
     );
    }
  });
}
 
 /**
  * 封装patch请求
  * @param url
  * @param data
  * @returns {Promise}
  */
 export function patch(url: any, data: any = {}) {
   return new Promise((resolve, reject) => {
     axios.patch(url, data).then(
       (response) => {
         resolve(response.data);
       },
       (err) => {
         msag(err);
         reject(err);
       }
     );
   });
 }
 
 /**
  * 封装put请求
  * @param url
  * @param data
  * @returns {Promise}
  */
 
 export function put(url: any, data: any = {}) {
   return new Promise((resolve, reject) => {
     axios.put(url, data).then(
       (response) => {
         resolve(response.data);
       },
       (err) => {
         msag(err);
         reject(err);
       }
     );
   });
 }
 
 //统一接口处理，返回数据
 export default function (fecth: any, url: any, param: any, config: any) {
   let _data = "";
   return new Promise((resolve, reject) => {
     switch (fecth) {
       case "get":
         console.log("begin a get request,and url:", url);
         get(url, param, config)
           .then(function (response) {
             resolve(response);
           })
           .catch(function (error) {
             console.log("get request GET failed.", error);
             reject(error);
           });
         break;
       case "post":
         post(url, param, config)
           .then(function (response) {
             resolve(response);
           })
           .catch(function (error) {
             console.log("get request POST failed.", error);
             reject(error);
           });
         break;
       default:
         break;
     }
   });
 }
 
 //失败提示
 function msag(err: any) {
   if (err && err.response) {
    //  switch (err.response.status) {
    //    case 400:
    //      alert(err.response.data.error.details);
    //      break;
    //    case 401:
    //      alert("未授权，请登录");
    //      break;
 
    //    case 403:
    //      alert("拒绝访问");
    //      break;
 
    //    case 404:
    //      alert("请求地址出错");
    //      break;
 
    //    case 408:
    //      alert("请求超时");
    //      break;
 
    //    case 500:
    //      alert("服务器内部错误");
    //      break;
 
    //    case 501:
    //      alert("服务未实现");
    //      break;
 
    //    case 502:
    //      alert("网关错误");
    //      break;
 
    //    case 503:
    //      alert("服务不可用");
    //      break;
 
    //    case 504:
    //      alert("网关超时");
    //      break;
 
    //    case 505:
    //      alert("HTTP版本不受支持");
    //      break;
    //    default:
    //  }
   }
 }
 
 /**
  * 查看返回的数据
  * @param url
  * @param params
  * @param data
  */
 function landing(url: any, params: any, data: any) {
   if (data.code === -1) {
   }
 }
 
 